import { Session } from '@ais-ui/auth';
import { Base64String } from '../utils';

export interface OverlayMetadata {
  targetCountInfo: string;
  timeUntilNextUpdate: number;
}

export interface GetOverlayProps {
  centerLat: number;
  centerLon: number;
  zoomLevel: number;
  width: number;
  height: number;
  leftLon: number;
  rightLon: number;
}

export const getOverlayMP = async (
  session: Session,
  props: GetOverlayProps,
  timeZone: string,
): Promise<{ overlay: Base64String; overlayCreatedDatetime: string }> => {
  const response = await session.request('getOverlayMP', {
    centerLat: props.centerLat,
    centerLon: props.centerLon,
    zoomLevel: Math.round(props.zoomLevel),
    width: props.width,
    height: props.height,
    serverUid: 'd4bd4710-1765-4476-8969-09ab9d0b676f',
    ran: 1,
    leftLon: props.leftLon,
    rightLon: props.rightLon,
    replayInterpolation: true,
    applicationName: 'marinepulse',
    timeZone: timeZone,
  });

  return response;
};

export const getOverlayMetadata = async (
  session: Session,
): Promise<OverlayMetadata> => {
  const response = await session.request('getTargetInfo', {});

  return response;
};
